import { dateFormatter } from "utils/formatters/date";

const CANCELLATION_DAYS_BY_STATE: Record<string, number> = {
  MO: 15,
};
const DEFAULT_CANCELLATION_DAYS = 14;

export function getCancelUntilDate(
  tripStartDate: string | Date | undefined,
  stateCode?: string | null,
) {
  if (!tripStartDate) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const tripStart = new Date(tripStartDate);

  const cancellationDays =
    (stateCode && CANCELLATION_DAYS_BY_STATE[stateCode]) ||
    DEFAULT_CANCELLATION_DAYS;

  const daysFromToday = new Date(today);
  daysFromToday.setDate(daysFromToday.getDate() + cancellationDays);

  let cancelUntil: Date;
  if (tripStart <= daysFromToday) {
    cancelUntil = new Date(tripStart);
    cancelUntil.setDate(cancelUntil.getDate() - 1);
  } else {
    cancelUntil = daysFromToday;
  }

  if (cancelUntil <= today) {
    return null;
  }

  return dateFormatter(cancelUntil, {
    style: "short",
    month: "short",
    day: "numeric",
  });
}
